import { render, staticRenderFns } from "./FresherCargo.vue?vue&type=template&id=237cfc37&scoped=true"
import script from "./FresherCargo.vue?vue&type=script&lang=js"
export * from "./FresherCargo.vue?vue&type=script&lang=js"
import style0 from "./FresherCargo.vue?vue&type=style&index=0&id=237cfc37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237cfc37",
  null
  
)

export default component.exports